import axios from 'axios';
import { ElMessageBox } from 'element-plus';
// 创建广播通道
var broadcast = new BroadcastChannel('tab-sync-channel');
// 监听刷新指令
broadcast.onmessage = function (e) {
    if (e.data === 'RELOAD_ALL_TABS') {
        window.location.reload();
    }
};
// 发送全局刷新指令的函数
var reloadAllTabs = function () {
    broadcast.postMessage('RELOAD_ALL_TABS');
    window.location.reload(); // 刷新当前标签页
};
var isNewVersion = function () {
    var _a;
    var url = "//".concat(window.location.host, "/version.json?t=").concat(new Date().getTime());
    (_a = axios.get(url)) === null || _a === void 0 ? void 0 : _a.then(function (res) {
        if (res.status === 200) {
            var vueVersion_1 = res.data.version || '1.0.0';
            var localVueVersion = localStorage.getItem('vueVersion');
            console.log('检测到新版本', res.data, localVueVersion, vueVersion_1);
            if (localVueVersion && localVueVersion != vueVersion_1) {
                ElMessageBox.confirm("<p class=\"ft14\" style=\"margin: 0 0 10px 0;\">\u68C0\u6D4B\u5230\u65B0\u7248\u672C\uFF0C\u53EF\u70B9\u51FB\u66F4\u65B0\u5237\u65B0\u9875\u9762\u3002</p>", '版本更新', {
                    customStyle: {
                        width: '320px',
                    },
                    center: true,
                    showClose: false,
                    showCancelButton: false,
                    dangerouslyUseHTMLString: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: '更新版本',
                    type: 'warning',
                })
                    .then(function () {
                    localStorage.setItem('vueVersion', vueVersion_1);
                    reloadAllTabs();
                })
                    .catch(function () { });
            }
            else {
                localStorage.setItem('vueVersion', vueVersion_1);
            }
        }
    });
};
export default {
    isNewVersion: isNewVersion
};
